var React = require('react');

function Tiktok (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M11.685.017C12.8,0,13.905.009,15.011,0A5.3,5.3,0,0,0,16.5,3.548,6,6,0,0,0,20.107,5.07V8.5a9.106,9.106,0,0,1-3.573-.825,10.511,10.511,0,0,1-1.378-.791c-.009,2.484.009,4.968-.017,7.444a6.5,6.5,0,0,1-1.149,3.352,6.338,6.338,0,0,1-5.028,2.731,6.2,6.2,0,0,1-3.471-.876,6.415,6.415,0,0,1-3.105-4.858c-.017-.425-.026-.851-.009-1.268A6.4,6.4,0,0,1,9.8,7.725c.017,1.259-.034,2.518-.034,3.777a2.919,2.919,0,0,0-3.726,1.8,3.375,3.375,0,0,0-.119,1.37A2.9,2.9,0,0,0,8.9,17.117a2.858,2.858,0,0,0,2.357-1.37,1.963,1.963,0,0,0,.349-.9c.085-1.523.051-3.037.06-4.56.009-3.428-.009-6.848.017-10.268Z","transform":"translate(-2.369)"}));
}

Tiktok.defaultProps = {"viewBox":"0 0 17.739 20.418"};

module.exports = Tiktok;

Tiktok.default = Tiktok;
